import type { SignalType } from '../../model/schema.js';
import { connectionEntities, defineRule, resolvedConnections } from '../rule.js';

/** Signal families; signals of the same family may be connected. */
const FAMILY: Record<SignalType, string> = {
  mic: 'analog',
  line: 'analog',
  instrument: 'analog',
  aes: 'aes',
  dante: 'network',
  ethernet: 'network',
  analog_multi: 'multi',
  speaker: 'speaker',
  dmx: 'dmx',
  power: 'power',
  wireless: 'wireless',
};

/** True when the signals belong to the same family (mic/line/instrument are interchangeable). */
export function signalsCompatible(a: SignalType, b: SignalType): boolean {
  return FAMILY[a] === FAMILY[b];
}

/** W: a cable joins incompatible signal types (e.g. speaker level into a mic input). */
export const signalTypeMismatch = defineRule(
  'signal-type-mismatch',
  'warning',
  { en: 'Signal type mismatch', de: 'Signaltyp passt nicht' },
  (data, emit) =>
    resolvedConnections(data)
      .filter(({ from, to }) => !signalsCompatible(from.signal, to.signal))
      .map(({ connection, from, to }) =>
        emit(connectionEntities(connection), { from: from.signal, to: to.signal }),
      ),
);
